export default {
    home_page_title: "Informações da conta",
    security_page_title: "Centro de Segurança",
    security_setting_page_title: "Centro de Segurança",
    security_phone_label: "Número de Celular",
    security_email_label: "E-mail",
    security_question_label: "Pergunta de Segurança",
    security_unset_text: "Não definido",
    security_setted_text: "Configurado",
    security_question_options: [
        "Nome da sua mãe?",
        "Aniversário de seu cônjuge?",
        "Nome de seu pai?",
        "Seu número de estudante ou de trabalhador?",
        "Seu melhor amigo de infância?",
        "Nome que mais lhe afeta?"
    ],
    password_lost_page_title: "Esqueci Senha",
    password_reset_page_title: "Redefinir a senha",
    password_lost_account_placeholder:
        "Favor inserir conta da qual esqueceu da senha",
    empty_lost_account_tips: "O nome do usuário não pode ficar vazio",
    iscorrect_lost_account_tips: "O usuário não existe",
    password_reset_new_placeholder: "Senha nova",
    password_reset_confirm_placeholder: "Comfirmar a senha nova",
    password_verify_page_title: "Autenticar identidade",
    phone_verify_page_title: "Autenticar identidade",
    email_verify_page_title: "Autenticar identidade",
    question_verify_page_title: "Autenticar identidade",
    phone_reset_page_title: "Número de Celular",
    email_reset_page_title: "E-mail",
    question_reset_page_title: "Pergunta de Segurança",
    phone_binding_text: "Seu celular vinculado é",
    email_binding_text: "Seu e-mail vinculado é",
    verification_code_text: "Código",
    resend_text: "Reenviar",
    empty_phone_number_tips: "Favor digite o seu número",
    iscorrect_phone_number_tips:
        "Favor digite o formato correto de número de telefone",
    empty_verification_code_tips: "Favor digite o código",
    iscorrect_verification_code_tips: "Erro do código",
    password_placeholder: "Senha",
    empty_password_tips: "Insira senha",
    iscorrect_password_tips: "Senha incorreta",
    mismatched_rule_password_tips: "Senha não poderá conter &, # ou spaces",
    different_confirm_password_tips: "Senha inconsistente",
    empty_email_tips: "Favor inserir e-mail",
    iscorrect_email_tips: "Erro de e-mail",
    answer_placeholder: "Resposta",
    empty_question_tips: "Escolhe as perguntas de segurança",
    empty_answer_tips: "Digite a resposta,",
    iscorrect_answer_tips: "A resposta está errada",
    next_step_text: "Próx.",
    submit_text: "Submeter",
    submit_success_tips: "Configurado com sucesso",
    submit_error_tips: "Falha na operação! Favor tente novamente.",
    get_data_fail_tips: "Erro de conexão, tente mais tarde",
    use_other_verification_type_text: "Outras formas de autenticação",
    custom_support_notice:
        "Ainda não definiu a segurança da conta, pode definir abrindo este link no PC." +
        process.env.VUE_APP_ORIGIN_PROFILE
};
